import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type Employee from 'modules/employees/store/models/Employee'

interface WrapperProps {
  employee: Employee
}

const ItemWrapper = ({ employee, children }: React.PropsWithChildren<WrapperProps>) => {
  const { navigation } = useNavigation()

  const employeeRoute = navigation.employees.id.fullPath({ id: employee.id })

  return <Table.Row.Router to={employeeRoute}>{children}</Table.Row.Router>
}

export default observer(ItemWrapper)
